module.exports = __webpack_public_path__ + "static/home-slideshow-02@2x-73fd4d1a987c954fc390059349580146.jpg";